























































import Vue from 'vue'
import ShopListingForm from './ShopListingForm.vue'
import { ShopCreateData, ShopListingData } from '../types'

export default Vue.extend({
  name: 'ListingAddForm',
  components: {
    ShopListingForm
  },
  props: {
    productsList: {
      required: true,
      type: Array
    },
    currenciesListArray: {
      required: true,
      type: Array
    },
    editedListing: {
      required: false,
      type: Object,
      default: () => ({})
    },
    formTitle: {
      required: false,
      type: String,
      default: () => ({})
    }
  },
  data () {
    return {
      listing: {} as any
    }
  },
  methods: {
    hideDialog () {
      this.$emit('hideListingForm')
    },
    onUpdatePriceCurrencies (currency: any) {
      if (!this.listing.price) {
        this.listing.price = {}
      }
      this.listing.price.currencies = currency
    },
    onUpdateSku (sku: string) {
      this.listing.sku = sku
    },
    onUpdateTags (tags: Array<string>) {
      this.listing.tags = tags
    },
    submit () {
      (this.$refs.shopListingForm as any).$validator.validateAll()
        .then((result: any) => {
          if (result) {
            if (this.editedListing.sku) {
              // form edit listing
              this.$emit('updateListing', this.editedListing._id, this.listing)
            } else {
              // form add listing
              this.$emit('addListing', this.listing)
            }
          }
        })
    }
  }
})
